import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import * as ch from "./contentHelper";
import $ from "jquery";

let to1 = 2000;

let popupCount;
export let setPopupCount = function(c){popupCount = c;};

let maxPopups = 3;
let isSpread = false;
let isSingle = false;
let popupWidth = 300;
let popupSpacing = 35;

export let getPopup = function(e, addClassName, headline, mapboxProperty, name, paragraph, infoBoxText, addTextAfterValue){
  popupCount = $('.map-popup').length + 1;
  if(popupCount < maxPopups +1){
    //----
    if(!Array.isArray(mapboxProperty)){
      mapboxProperty = [mapboxProperty];
      name = [name];
      paragraph = [paragraph];
    }
    let html = '';
    for(let i = 0; i < mapboxProperty.length; i++){
      if(i == 0){
        html += ch.getHead(e,headline, addClassName, e.lngLat);
      }

      if(typeof(infoBoxText) !== undefined){
        if(infoBoxText[i] != ''){
          html += "<div class='value-and-info'>";
          html += ch.getValue(e, mapboxProperty[i], addTextAfterValue[i]);
          html += "<div class='info-icon'></div>";
          html += "<div class='info-text info-nr-" +i + "'>" + infoBoxText[i];
          html += '</div>';
          html += '</div>';
        }else{
          html += ch.getValue(e, mapboxProperty[i], addTextAfterValue[i]);
        }
      }

      html += ch.getName(name[i]);
      html += ch.getParagraph(paragraph[i]);
      if(i < mapboxProperty.length-1){
        html+=ch.getSeparator();
      };
    }
    html += "</div></div>";
    //----

    var pop = new mapboxgl.Popup({className: 'big ' + 'popup-'+popupCount + ' ' + addClassName, closeOnClick: false, autoClose: false })
    .setLngLat(e.lngLat)
    .setHTML(
      html
      // ch.getHead(e,headline, addClassName, e.lngLat)+
      // ch.getValue(e, mapboxProperty)+
      // ch.getName(name)+
      // ch.getParagraph(paragraph)+
      // ch.getSeparator()+
      // "</div></div>"
      ).addTo(m.map);
    pop.on('close', function(e) {
        popupCount = $('.map-popup').length + 1;
        reorderPopups();
        hideNotice(10);
    });
  }else{
    showNotice();
  }
  reorderPopups();
};

//REORDER POPUPS
let reorderPopups = function(){
  popupCount = $('.map-popup').length;
  $('.mapboxgl-popup.big').each(function(index) {
    if($('.mapboxgl-popup.big').length == 1){
      isSingle = true;
      $( this ).alterClass('popup-*', 'popup-single');
      $( this ).addClass('spread');
      $( this ).css('left', '80px');
    }else{
      isSingle = false;
      $( this ).alterClass('popup-*', 'popup-'+(index));
      $( this ).removeClass('spread');
      $( this ).css('left', ((popupCount-index-1)*50) + 78 +'px');
    }
    if(isSpread){
      $( this ).addClass('spread');
      $( this ).css('left', (index*popupWidth)+popupSpacing+45+'px');
    }else{
      $( this ).removeClass('spread');
    }
  });
};

//POPUPS SPREAD
$('body').on('mouseenter', '.mapboxgl-popup.big', function() {
  clearTimeout(to1);
  //isSpread = !isSpread;
  if(isSpread){
    //$('.mapboxgl-popup').addClass('spread'); 
  }else{
    $('.mapboxgl-popup').addClass('spread'); 
    isSpread = true;
  }
  reorderPopups();
});

//MAX POPUP NOTICE
let showNotice = function(){
  $('.notice').stop().fadeIn('fast', function(){
    fadeOutNotice(3000);
  });
};
let hideNotice = function(t){
  $('.notice').stop().fadeOut();
};
let fadeOutNotice = function(t){
  $('.notice').delay(t).fadeOut('fast', function(){});
};

// SET SPREAD FALSE
let setSpreadFalse = function(){
  isSpread = false;
  $('.mapboxgl-popup').removeClass('spread');
  reorderPopups();
};

//POPUP MOUSE LEAVE
$('body').on('mouseleave', '.mapboxgl-popup', function() {
  clearTimeout(to1);
  to1 = setTimeout(setSpreadFalse, 600);
});

//CLICK POPUP REGION NAME
$('body').on('click', '.popup-head a', function(e) {
  e.preventDefault();
  let lat = $(this).attr("data-lat");
  let lng = $(this).attr("data-lng");
  m.flyTo(lat, lng);
  //return false;
});

//CLICK INFO
let infoWasVisible = false;
$('body').on('click', '.info-icon', function(e) {
  let infoTextAll = $('.info-text');
  e.preventDefault();
  let valueAndInfos = $('value-and-info');
  let index = $(this).closest('.popup-body').find('.value-and-info').index($(this).parent());
  let infoText = $(this).parent().parent().find('.info-text').eq(index);
  if(infoText.css('display') == 'block'){
    infoWasVisible = true;
  }else{
    infoWasVisible = false;
  }
  infoTextAll.hide();
  if(!infoWasVisible){
    infoText.fadeIn('fast');
  }
});

//CLICK INFO TEXT
$('body').on('click', '.info-text', function(e) {
  e.preventDefault();
  $(this).fadeOut('fast');
});


